<template>
  <div>
    <h3
      id="table_1"
      class="mt-3"
    >
      Aantal laadpunten dat rijksbreed wordt gevraagd en er zijn gerealiseerd
    </h3>
    <p class="mb-4">
      Er wordt onderscheid gemaakt tussen de behoefte op basis van de 4% regel en de extra behoefte welke tijdens de aanvraag werd opgemerkt.
    </p>
    <TableManager
      ref="TableManager"
      class="RVBChargingpointCount"
      :loading="loading"
      :source-records="records"
      category="rvb-customer-reporting"
      uuid="10deca9b-d99b-4f0c-a1f7-1db51d58d562"
    />
  </div>
</template>

<script>

import TableManager from '@/components/Table/TableManager'
import { mapGetters } from 'vuex'

export default {
  name: '',
  components: {
    TableManager,
  },

  computed: {
    ...mapGetters('realisation', [
      'records',
      'loading',
    ]),
  },

}
</script>

<style lang="scss">
.RVBChargingpointCount {
  // .Table__row {
  //   div:first-child {
  //     font-weight: bold;
  //   }
  // }
  .Table__row:last-child {
    font-weight: bold;
  }
}
</style>
